export * from './age-gate.component';
export * from './min-age.service';
import './age-gate.config';
